// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-n_fT","advertDetailContactItem__link":"c-n_fU"};